/**
 * Created by Christof Sander on 29.01.2017.
 */

module.exports = {
	model: {
		active: false,
		sidePanels: [],
		activeSidePanelIndexes: []
	},

	events: {
		navigation: {
			type: 'click',
			action: function(event){
				var $target = $(event.target);
				var $realTarget;
				var href;

				if(($realTarget = $target.closest('a')).length > 0 && (href = $realTarget.attr('href'))){
					if(href.indexOf('mailto') < 0 && !$realTarget.data('type')){
						event.preventDefault();
						var urlParts = href.split('#');
						if(urlParts.length > 1){
							event.data.component.to(urlParts[0], urlParts[1]);
						}
						else {
							event.data.component.to(href);
						}
					}
				}
				else if(($realTarget = $target.closest('img.logo')).length > 0){
					// TODO: url hard coded?!
					event.data.component.model.gridNavigator.to('/de/startseite', undefined, undefined, 0);
				}
				else if(($realTarget = $target.closest('.templates_headPanel_navButton')).length > 0){
					event.data.component.toggle();
				}
				else if(($realTarget = $target.closest('section.backPanel')).length > 0){
					event.data.component.model.gridNavigator.back();
				}
				else if(($realTarget = $target.closest('.templates_headPanel_columnMenu > li')).length > 0){
					event.data.component.model.gridNavigator.to(undefined, $realTarget.data('routeComponentId'));
				}
				else if(($realTarget = $target.closest('.background')).length > 0){
					event.data.component.hide();
				}
			}
		}
	},

	methods: {
		show: function(){
			this.model.active = true;
			this.$.find('.templates_headPanel_navButton').addClass('mainNavButtonX active');
			this.$.find('section.sidePanels, .templates_headPanel_sidePanel.mainNav').addClass('active');
			this.model.gridNavigator.switchAdditionalStyle(getComponent(this.$.find('.templates_headPanel_sidePanel.mainNav')));
		},

		hide: function(){
			if(this.model.directPanelOpen){
				this.model.directPanelOpen = false;
				this.hideOpenPanels();
			}
			else {
				if(this.model.activeSidePanelIndexes.length > 0){
					var sp, maxSP = this.model.activeSidePanelIndexes.length;
					for(sp = 0; sp < maxSP; sp++){
						this.model.sidePanels[this.model.activeSidePanelIndexes.pop()].component.$.removeClass('active')
					}
					this.model.activeSidePanelIndexes = [];
				}
				this.model.active = false;
				this.$.find('.templates_headPanel_navButton').removeClass('mainNavButtonX active');
				this.$.find('section.sidePanels, .templates_headPanel_sidePanel.mainNav').removeClass('active');
				this.model.gridNavigator.switchAdditionalStyle();
			}
		},

		toggle: function(){
			if(this.model.active)   this.hide();
			else                    this.show();
		},

		to: function(route, anchor, directPanelOpen){
			var gridNavigatorInCharge = true;
			var panelComponent;
			var panelIndex;
			for(panelIndex in this.model.sidePanels){
				if(this.model.sidePanels[panelIndex].route == route && !anchor){
					panelComponent          = this.model.sidePanels[panelIndex].component;
					gridNavigatorInCharge   = (panelComponent.model.type.data != 'contact' && panelComponent.model.type.data != 'contact-form' && this.activeEnvironment.style == 'desktop');
					break;
				}
			}

			// gridNavigator should perform a transition to the target route
			if(gridNavigatorInCharge){
				this.hideOpenPanels();
				this.model.gridNavigator.to(route, undefined, anchor, (!anchor ? 0 : undefined));
			}
			// headPanel should switch to the target-panel
			else {
				this.switchToPanel(panelComponent, panelIndex, !!directPanelOpen);
			}
		},

		switchToPanel: function(panelComponent, panelIndex, directPanelOpen){
			if((this.model.directPanelOpen = directPanelOpen)){
				this.show();
			}
			this.model.activeSidePanelIndexes.push(panelIndex);
			panelComponent.$.addClass('active');
			this.model.gridNavigator.switchAdditionalStyle(panelComponent);
		},

		hideOpenPanels: function(){
			var nrOfActivePanels = this.model.activeSidePanelIndexes.length;
			for(var i = 0; i <= nrOfActivePanels; i++){
				this.hide();
			}
		},

		morph: function(column, routeComponentID, route, anchor){
			if(this.model.columnMenuComponent) {
				var columnMenu;
				if(this.activeEnvironment.style === 'mobile'){
					var breadCrumbs = this.model.gridNavigator.model.routes[route].breadCrumbs || [];
					this.model.columnMenuComponent.model.title = ((breadCrumbs[breadCrumbs.length - 1] || {}).name || '').toUpperCase();
					this.model.columnMenuComponent.model.activeElementNr = column.getHumanReadableWindowIndex();
					this.model.columnMenuComponent.model.nrOfElements = column.model.properties.nrOfActiveWindows;
					this.model.columnMenuComponent.refresh();
				}
				else if((columnMenu = column.model.properties.columnMenu) && columnMenu.nrOfActiveMenuElements > 0){
					// remove menu elements which are assigned to inactive windows only
					var menuElements = {};
					for(var subMenuName in columnMenu.menu){
						if(columnMenu.nrOfActiveWindows[subMenuName] > 0){
							menuElements[subMenuName] = columnMenu.menu[subMenuName];
						}
					}

					this.model.columnMenuComponent.model.elements = menuElements;
					this.model.columnMenuComponent.model.activeRouteComponentID = columnMenu.menu[columnMenu.windowList[routeComponentID]];
					this.model.columnMenuComponent.refresh();
				}
				else {
					this.model.columnMenuComponent.clear();
				}
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				var self = this;

				// generate shortcuts for often used components
				this.closest('layouts_gridNavigator_gridNavigator', function(gridComponent){
					self.model.gridNavigator = gridComponent;
				});
				this.find('templates_headPanel_columnMenu', function(columnMenuComponent){
					self.model.columnMenuComponent = columnMenuComponent;
				});

				// build sidePanel-list
				this.find('templates_headPanel_sidePanel', function(sidePanelComponent){
					self.model.sidePanels.push({
						route:      sidePanelComponent.model.route && sidePanelComponent.model.route.data ? sidePanelComponent.model.route.data : '',
						component:  sidePanelComponent
					});
				});
			}
		}
	}
};
